import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/billing.png'
import _imports_1 from '../assets/images/filetext.png'


const _hoisted_1 = { class: "billingPageView" }
const _hoisted_2 = {
  key: 0,
  class: "pageConetent"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Billing ")
], -1)
const _hoisted_5 = { class: "right" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Credits Remaining ")
const _hoisted_7 = { class: "cCount" }
const _hoisted_8 = { class: "addcreditSec" }
const _hoisted_9 = { class: "left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Add Credit to your Account", -1)
const _hoisted_11 = { class: "body" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "How many credits would you like to add?", -1)
const _hoisted_13 = { class: "numeric-input-title" }
const _hoisted_14 = { class: "nfield" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "nlabel" }, "credits", -1)
const _hoisted_16 = { class: "pricelists" }
const _hoisted_17 = { class: "right" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Order Summary", -1)
const _hoisted_19 = { class: "body" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "totalSec" }
const _hoisted_22 = { class: "subtotal" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, "Subtotal", -1)
const _hoisted_24 = { class: "right" }
const _hoisted_25 = { class: "subtotal" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, "Total", -1)
const _hoisted_27 = { class: "right" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Continue to Checkout ")
const _hoisted_29 = { class: "invoicSec" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" Invoice ")
  ])
], -1)
const _hoisted_31 = { class: "tableSec" }
const _hoisted_32 = {
  key: 0,
  class: "actionblock"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("View Invoice")
const _hoisted_34 = {
  key: 1,
  class: "actionblock"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode("No access")
const _hoisted_36 = {
  key: 1,
  class: "paymentContainer"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Payment "),
  /*#__PURE__*/_createElementVNode("span", null, "Gateway")
], -1)
const _hoisted_38 = { class: "cell paymentSec stripeCElement" }
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"field\"><input id=\"stripeCElement-name\" class=\"input empty\" type=\"text\" placeholder=\"Tony Nguyen\" required=\"\"><label for=\"stripeCElement-name\">Name on card</label><div class=\"baseline\"></div></div></div><div class=\"row\"><div class=\"field\"><div id=\"stripeCElement-card-number\" class=\"input empty\"></div><label for=\"stripeCElement-card-number\">Card Number</label><div class=\"baseline\"></div></div></div><div class=\"row\"><div class=\"field half-width\"><div id=\"stripeCElement-card-expiry\" class=\"input empty\"></div><label for=\"stripeCElement-card-expiry\">Expiration</label><div class=\"baseline\"></div></div><div class=\"field half-width\"><div id=\"stripeCElement-card-cvc\" class=\"input empty\"></div><label for=\"stripeCElement-card-cvc\">CVC</label><div class=\"baseline\"></div></div></div>", 3)
const _hoisted_42 = { class: "subBtns" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  class: "error",
  role: "alert"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode()
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "message" }, null, -1)
const _hoisted_48 = { class: "success" }
const _hoisted_49 = { class: "icon" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h3", {
  class: "title",
  "data-tid": "elements_examples.success.title"
}, " Payment successful ", -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_52 = {
  class: "reset",
  href: "#",
  style: {"display":"none"}
}
const _hoisted_53 = {
  key: 2,
  class: "spinners"
}
const _hoisted_54 = { class: "priceListSec" }
const _hoisted_55 = { class: "tableSec" }
const _hoisted_56 = { class: "status" }
const _hoisted_57 = { class: "footersec" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Ok")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_EyeInvisibleOutlined = _resolveComponent("EyeInvisibleOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")!
  const _component_UndoOutlined = _resolveComponent("UndoOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showcheckoutpage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.avilableCredit), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_a_tooltip, {
                  trigger: ['focus'],
                  placement: "topLeft",
                  "overlay-class-name": "numeric-input"
                }, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_input_number, {
                        value: _ctx.totalCredits,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.totalCredits) = $event)),
                        "allow-clear": "",
                        min: 1,
                        "max-length": 10,
                        formatter: _ctx.limitNumber,
                        parser: _ctx.limitNumber,
                        onBlur: _ctx.onCreditBlur
                      }, null, 8, ["value", "formatter", "parser", "onBlur"]),
                      _hoisted_15
                    ])
                  ]),
                  _: 2
                }, [
                  (_ctx.totalCredits)
                    ? {
                        name: "title",
                        fn: _withCtx(() => [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.totalCredits), 1)
                        ])
                      }
                    : undefined
                ]), 1024),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewPriceList && _ctx.viewPriceList(...args)))
                  }, "View price list")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("small", null, [
                  _createTextVNode(_toDisplayString(_ctx.totalCredits) + " Credits ", 1),
                  (_ctx.totalCost?.total && _ctx.totalCredits)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "x " + _toDisplayString(_ctx.totalCost.price_per_unit) + " = £" + _toDisplayString(_ctx.totalCost.total), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, " £" + _toDisplayString(_ctx.totalCost?.total ? _ctx.totalCost.total : 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, " £" + _toDisplayString(_ctx.totalCost?.total ? _ctx.totalCost.total : 0), 1)
                  ])
                ]),
                (_ctx.commonService.checkPermission('Billing', 'create'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      block: "",
                      class: "checkout-btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkoutPage()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_a_table, {
                columns: _ctx.invoiceColumns,
                "data-source": _ctx.invoiceLists,
                class: "ant-table-striped",
                rowKey: "id",
                pagination: false
              }, {
                date: _withCtx(({ record }) => [
                  _createTextVNode(_toDisplayString(_ctx.moment(record.created_at, "YYYY-MM-DD hh:mm").format(
                  "DD.MM.YYYY"
                )), 1)
                ]),
                price: _withCtx(({ record }) => [
                  _createTextVNode(" £" + _toDisplayString(record.amount), 1)
                ]),
                action: _withCtx(({ record }) => [
                  (_ctx.commonService.checkPermission('Invoices', 'download'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createVNode(_component_a_tooltip, null, {
                          title: _withCtx(() => [
                            _hoisted_33
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_EyeOutlined, {
                              onClick: ($event: any) => (_ctx.viewInvoice(record)),
                              style: { fontSize: '15px' }
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(_component_a_tooltip, null, {
                          title: _withCtx(() => [
                            _hoisted_35
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_EyeInvisibleOutlined, { style: { fontSize: '15px' } })
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }, 8, ["columns", "data-source"]),
              _createVNode(_component_a_pagination, {
                class: "Tlistpagination",
                "show-size-changer": "",
                current: _ctx.currentPage,
                "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
                pageSize: _ctx.pageSize,
                "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
                total: _ctx.totalNoofInvoices,
                onChange: _ctx.onPageChange,
                onShowSizeChange: _ctx.onShowSizeChange
              }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showcheckoutpage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("form", null, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  block: "",
                  class: "cancle-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.canclePayment()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_43
                  ]),
                  _: 1
                }),
                _createElementVNode("input", {
                  type: "submit",
                  value: 'Pay £' + _ctx.totalCost?.total
                }, null, 8, _hoisted_44)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_CloseCircleFilled),
                _hoisted_46,
                _hoisted_47
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_a_spin, { tip: "Loading..." }),
                _createVNode(_component_CheckCircleOutlined, { class: "succesicon" })
              ]),
              _hoisted_50,
              _createVNode(_component_a_button, {
                type: "primary",
                block: "",
                class: "contionue-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.payementSucesfull()))
              }, {
                default: _withCtx(() => [
                  _hoisted_51
                ]),
                _: 1
              }),
              _createElementVNode("a", _hoisted_52, [
                _createVNode(_component_UndoOutlined)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pageLoder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      title: "Price List",
      width: "500px",
      class: "candidate-dashboard-modal pricelistModal",
      visible: _ctx.pricelistVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pricelistVisible) = $event)),
      "cancel-button-props": { style: 'display:none' },
      "ok-button-props": { style: 'display:none' },
      maskClosable: false,
      destroyOnClose: true,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_a_table, {
              columns: _ctx.allPriceColumns,
              "data-source": _ctx.allPriceLists,
              class: "",
              rowKey: "id",
              pagination: false
            }, {
              price: _withCtx(({ record }) => [
                _createElementVNode("div", _hoisted_56, " £" + _toDisplayString(record.price_per_unit), 1)
              ]),
              _: 1
            }, 8, ["columns", "data-source"])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_a_button, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clocePriceList()))
            }, {
              default: _withCtx(() => [
                _hoisted_58
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}